import {
  presignConversationGroupImage,
  putToPresignedUrl,
} from '@vgrubs/components';

/**
 * Puts a group photo in Spaces and hands back the key to reference it by.
 *
 * Group images do not go through the usual multipart upload: they are presigned
 * and PUT straight to Spaces like a chat attachment, and the `key` that comes
 * back is what the create and update calls carry.
 *
 * Returns undefined when there is nothing to upload - no image at all, or a
 * string, which is the existing url rather than a new file.
 */
export const uploadGroupImage = async (
  image: File | Blob | string | null
): Promise<string | undefined> => {
  if (!image || typeof image === 'string') return undefined;

  const file = image as File;
  const { data } = await presignConversationGroupImage({
    mime: file.type,
    size: file.size,
    name: file.name,
  });

  await putToPresignedUrl({
    url: data.data.uploadUrl,
    headers: data.data.headers,
    body: file,
  });

  return data.data.key;
};
